import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    FruitfulCustomIcon,
    H2Emphasized,
    View,
    YStack,
} from 'smoothie';

interface AccountOpenSuccessProps {
    isJointInvitation: boolean;
    onPressNext: () => void;
}

const AccountOpenSuccess = ({
    isJointInvitation,
    onPressNext,
}: AccountOpenSuccessProps) => {
    return (
        <YStack gap={24} justifyContent="space-between">
            <View>
                <View alignSelf="center" marginBottom={30}>
                    <FruitfulCustomIcon size="xl" showShadow />
                </View>
                <H2Emphasized
                    textAlign="center"
                    marginBottom={14}
                    marginHorizontal={24}
                >
                    {!isJointInvitation && (
                        <>Your Fruitful Cash{'\n'}Account is open!</>
                    )}
                    {isJointInvitation && (
                        <>You&apos;ve joined the{'\n'}Fruitful Cash Account!</>
                    )}
                </H2Emphasized>
                {!isJointInvitation && (
                    <BodyMediumRegular textAlign="center" color="$gray1100">
                        Now, let&apos;s fund it.
                    </BodyMediumRegular>
                )}
            </View>

            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text="Continue"
                onPress={onPressNext}
            />
        </YStack>
    );
};

export default AccountOpenSuccess;
